class AppConfig {
  getBaseUrl(): string {
    // const baseUrl = "https://smb-vzmsg-dev.ott.vzmlab.com/api";
    // const baseUrl ="https://raineesh.lirisoft.net/api";
      const baseUrl ="https://api-smbserver.lirisoft.net/api";


    return baseUrl;
  }
}

const appConfig = new AppConfig();

export default appConfig;
